/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GynicHistory from './gynic-history';
import GynicHistoryDetail from './gynic-history-detail';
import GynicHistoryUpdate from './gynic-history-update';
import GynicHistoryDeleteDialog from './gynic-history-delete-dialog';

const GynicHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GynicHistory />} />
    <Route path="new" element={<GynicHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<GynicHistoryDetail />} />
      <Route path="edit" element={<GynicHistoryUpdate />} />
      <Route path="delete" element={<GynicHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GynicHistoryRoutes;
